import { AdapterBase } from 'pqb/internal';
import {
  createMigrationInterface,
  ChangeCallback,
  introspectDbSchema,
  RakeDbConfig,
} from 'rake-db';
import { composeMigration, ComposeMigrationParams } from './composeMigration';
import { AbortSignal } from './generate';

const rollbackErr = new Error('Rollback');

export const verifyMigration = async (
  adapter: AdapterBase,
  config: RakeDbConfig,
  migrationCode: string,
  generateMigrationParams: ComposeMigrationParams,
  roles?: { whereSql?: string },
  defaultPrivileges?: { loadDefaultPrivileges?: boolean },
): Promise<string | false | undefined> => {
  const migrationFn = new Function('change', migrationCode);

  let code: string | false | undefined;

  try {
    await adapter.transaction(async (trx) => {
      const changeFns: ChangeCallback<unknown>[] = [];
      migrationFn((changeCb: ChangeCallback<unknown>) => {
        changeFns.push(changeCb);
      });

      const { log } = config;
      config.log = false;

      const db = createMigrationInterface(trx, true, config).getDb(
        config.columnTypes,
      );

      config.log = log;

      for (const changeFn of changeFns) {
        await changeFn(db, true);
      }

      const dbStructure = await introspectDbSchema(trx, {
        roles,
        loadDefaultPrivileges: defaultPrivileges?.loadDefaultPrivileges,
      });
      generateMigrationParams.verifying = true;

      try {
        code = await composeMigration(
          trx,
          config,
          [],
          dbStructure,
          generateMigrationParams,
        );
      } catch (err) {
        if (err instanceof AbortSignal) {
          code = false;
          throw rollbackErr;
        }
        throw err;
      }

      throw rollbackErr;
    });
  } catch (err) {
    if (err !== rollbackErr) {
      throw err;
    }
  }

  return code;
};
